export default __webpack_public_path__ + "static/media/box.0b5ad8d5.png";